import { Link } from "react-router";
import { useTranslations } from "use-intl";
import { Layers, PlayCircle, TrendingUp, Trophy } from "lucide-react";
import { LanguageSwitch } from "@/components/app/language-switch";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useConfig } from "@/lib/queries";

export function LandingPage() {
  const t = useTranslations("landing");
  const tAuth = useTranslations("auth");
  const signup = useConfig().data?.signup;
  const features = [
    { icon: PlayCircle, title: t("f1Title"), text: t("f1Text") },
    { icon: TrendingUp, title: t("f2Title"), text: t("f2Text") },
    { icon: Trophy, title: t("f3Title"), text: t("f3Text") },
    { icon: Layers, title: t("f4Title"), text: t("f4Text") },
  ];
  return (
    <main className="relative mx-auto flex w-full max-w-md flex-1 flex-col overflow-hidden px-5 pb-10 pt-safe">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 -z-10 size-[520px] -translate-x-1/2 rounded-full bg-primary/25 blur-3xl"
      />
      <div className="flex items-center justify-between pt-4">
        <div className="flex items-center gap-2 font-bold">
                    <img src="/icon.svg" alt="" className="size-8 rounded-lg" />
          LiftQuest
        </div>
        <LanguageSwitch />
      </div>

      <div className="mt-14">
        <Badge variant="secondary" className="mb-4">
          {t("badge")}
        </Badge>
        <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-balance">{t("title")}</h1>
        <p className="mt-4 text-lg text-muted-foreground text-pretty">{t("subtitle")}</p>
      </div>

      <div className="mt-8 flex flex-col gap-3">
        {signup === false ? (
          // Sign-up switched off on the server: login becomes the main action.
          <Button asChild size="lg" className="h-13 rounded-2xl text-base">
            <Link to="/login">{tAuth("login")}</Link>
          </Button>
        ) : (
          <>
            <Button asChild size="lg" className="h-13 rounded-2xl text-base">
              <Link to="/register">{t("register")}</Link>
            </Button>
            <Button asChild size="lg" variant="ghost" className="h-12 rounded-2xl text-base">
              <Link to="/login">{t("login")}</Link>
            </Button>
          </>
        )}
      </div>

      <ul className="mt-10 grid grid-cols-2 gap-3">
        {features.map(({ icon: Icon, title, text }) => (
          <li key={title} className="rounded-2xl border bg-card p-4">
            <Icon className="size-6 text-primary" />
            <h2 className="mt-3 font-semibold leading-tight">{title}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{text}</p>
          </li>
        ))}
      </ul>
    </main>
  );
}
